var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_vm.loading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "article, list-item-two-line, list-item-two-line, list-item-two-line"
    }
  }) : _vm.conversation ? _c('div', {
    staticClass: "conversation-detail-container"
  }, [_c('v-card', {
    staticClass: "conversation-header",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-subtitle-1 py-2"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "large": ""
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _vm.isDetailLoading ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "size": "16",
      "width": "2",
      "color": "primary",
      "indeterminate": ""
    }
  }) : _c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.channelIcon))]), _vm._v(" " + _vm._s(_vm.conversation.participantPhoneE164 || _vm.conversation.identifier) + " "), _c('v-spacer'), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-chip', _vm._g(_vm._b({
          attrs: {
            "color": _vm.statusColor,
            "small": "",
            "outlined": ""
          }
        }, 'v-chip', attrs, false), on), [_vm._v(" " + _vm._s(_vm.$t("enums.ConversationStatusEnum.".concat(_vm.conversation.status))) + " ")])];
      }
    }])
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-caption text--secondary"
  }, [_vm._v(" " + _vm._s(_vm.$t("created")) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.conversation.timestamp.createdReadable) + " ")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-caption text--secondary"
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.conversation.status")) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$t("enums.ConversationStatusEnum.".concat(_vm.conversation.status))) + " ")])], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-caption text--secondary"
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.conversation.channel")) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.conversation.channel) + " ")])], 1)], 1), _vm.isWhatsappChannel && _vm.conversation.whatsappSessionExpiresAt ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-caption text--secondary"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerConversationView.whatsappSessionExpiresAt")) + " ")]), _c('v-list-item-subtitle', {
    class: {
      'warning--text': _vm.isWhatsappSessionExpired || _vm.isWhatsappSessionExpiringSoon
    }
  }, [_vm._v(" " + _vm._s(_vm.whatsappSessionExpiresAtReadable) + " "), !_vm.isWhatsappSessionExpired && _vm.whatsappExpiresInText ? _c('span', {
    staticClass: "text-caption"
  }, [_vm._v(" (" + _vm._s(_vm.whatsappExpiresInText) + ") ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm.conversation.status === _vm.ConversationStatusEnum.ACTIVE ? _c('v-divider') : _vm._e(), _vm.conversation.status === _vm.ConversationStatusEnum.ACTIVE ? _c('v-list-item', {
    attrs: {
      "disabled": _vm.isClosing
    },
    on: {
      "click": function click($event) {
        return _vm.closeConversation(_vm.conversation);
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": _vm.conversation.closedColor
    }
  }, [_vm._v("mdi-check-circle-outline")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerConversationView.close")) + " ")])], 1), _vm.isClosing ? _c('v-list-item-action', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "16",
      "width": "2"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm.conversation.subject ? _c('v-card-subtitle', {
    staticClass: "pb-2"
  }, [_vm._v(" " + _vm._s(_vm.conversation.subject) + " ")]) : _vm._e(), _c('v-divider')], 1), _c('div', {
    ref: "chatContainer",
    staticClass: "chat-messages-container"
  }, [_vm.sortedMessages.length ? _c('div', {
    staticClass: "chat-messages"
  }, [_vm.hasMoreMessages ? _c('div', {
    staticClass: "text-center py-3"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "small": "",
      "color": "primary",
      "loading": _vm.isLoadingMore
    },
    on: {
      "click": _vm.loadMoreMessages
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerConversationView.loadMore")) + " ")], 1)], 1) : _vm._e(), _vm._l(_vm.sortedMessages, function (message) {
    return _c('partner-conversation-chat-message', {
      key: message.id,
      attrs: {
        "value": message
      }
    });
  })], 2) : _c('div', {
    staticClass: "chat-empty text-center pa-8"
  }, [_c('v-icon', {
    attrs: {
      "size": "64",
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-message-outline")]), _c('p', {
    staticClass: "text--secondary mt-4"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerConversationView.noMessages")) + " ")])], 1)]), _c('div', {
    staticClass: "chat-input-container"
  }, [_c('v-divider'), _c('div', {
    staticClass: "chat-input-wrapper pa-3"
  }, [_c('v-textarea', {
    staticClass: "chat-input",
    attrs: {
      "placeholder": _vm.$t('components.PartnerConversationView.typeMessage'),
      "outlined": "",
      "dense": "",
      "auto-grow": "",
      "rows": "1",
      "hide-details": "",
      "disabled": _vm.isSending || _vm.conversation.status !== _vm.ConversationStatusEnum.ACTIVE
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnterKey.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "color": "primary",
            "disabled": !_vm.canSend,
            "loading": _vm.isSending
          },
          on: {
            "click": _vm.sendMessage
          }
        }, [_c('v-icon', [_vm._v("mdi-send")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.newMessage,
      callback: function callback($$v) {
        _vm.newMessage = $$v;
      },
      expression: "newMessage"
    }
  }), _vm.conversation.status !== _vm.ConversationStatusEnum.ACTIVE ? _c('div', {
    staticClass: "text-caption text--secondary mt-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerConversationView.conversationClosed")) + " ")]) : _vm.isWhatsappSessionExpired ? _c('div', {
    staticClass: "text-caption warning--text mt-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": "",
      "color": "warning"
    }
  }, [_vm._v("mdi-alert")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerConversationView.whatsappSessionExpired")) + " ")], 1) : _vm.isWhatsappSessionExpiringSoon ? _c('div', {
    staticClass: "text-caption warning--text mt-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": "",
      "color": "warning"
    }
  }, [_vm._v("mdi-clock-alert-outline")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerConversationView.whatsappSessionExpiringSoon", {
    time: _vm.whatsappExpiresInText
  })) + " ")], 1) : _vm._e()], 1)], 1)], 1) : _c('latest-entries-card-empty')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }